module.exports = __webpack_public_path__ + "static/media/42x38-9.13725a39.png";